export default function Container(_theme) {
  return {
    MuiContainer: {
      styleOverrides: {
        root: {
          '@media (min-width:2000px)': {
            maxWidth: '1600px',
          },
        },
      },
    },
  };
}

